import { Button } from '@cimplico/components';
import { useState } from 'react';
import FYIDocumentViewer from './FYIDocumentViewer';
import { useIsActiveSubscription } from '../../../../../../hooks/use-is-active-subscription';

type FYIEntityFileSelectProps = {
    id: number;
    name: string;
    entityId: string;
};
function FYIEntityFileSelect({ id, name, entityId }: FYIEntityFileSelectProps): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);
    const activeSubscription = useIsActiveSubscription();

    return (
        <div>
            <Button
                type="secondary"
                size="sm"
                label="Select from cabinets"
                onClick={(): void => setIsOpen(true)}
                disabled={!activeSubscription}
            />
            {isOpen && <FYIDocumentViewer onClose={(): void => setIsOpen(false)} entityName={name} entityId={entityId} fyiEntityId={id} />}
        </div>
    );
}

export default FYIEntityFileSelect;
